import { StepperContainer, StepConnector } from './formStepper.styled';
import StepItem from './stepItem';
import { labelToKey } from 'utils/formLabelsToKey';

type FormStepperProps = {
    currentStep: number;
    options: string[];
    handleFormChange: (val: string) => void;
    completedForms: Record<string, boolean>;
    isPersonalInfoCompleted?: boolean;
};

export default function FormStepper({
    currentStep,
    options,
    handleFormChange,
    completedForms,
    isPersonalInfoCompleted,
}: FormStepperProps) {
    return (
        <StepperContainer>
            {options.map((label, index) => {
                const key = labelToKey[label];
                const isCompleted = key ? completedForms[key] : false;

                let status: 'done' | 'current' | 'upcoming';
                if (isCompleted) {
                    status = 'done';
                } else if (index === currentStep - 1) {
                    status = 'current';
                } else {
                    status = 'upcoming';
                }

                // Determine if this step is clickable
                // First step (Personal Info) is always clickable
                // Other steps are clickable only if Personal Info is completed OR they're already completed
                const isClickable = index === 0 || isPersonalInfoCompleted || isCompleted;

                const isLast = index === options.length - 1;
                const isActive = index === currentStep - 1;
                return (
                    <div key={label} style={{ position: 'relative' }}>
                        <StepItem
                            label={label}
                            status={status}
                            onClick={() => isClickable && handleFormChange(label)}
                            isActive={isActive}
                            isClickable={isClickable}
                        />
                        {!isLast && <StepConnector status={status} />}
                    </div>
                );
            })}
        </StepperContainer>
    );
}
